import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { SelectFieldOne, PhoneInputField, TextInputFixedLabel, CheckBox } from "master-react-lib";

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import Button from '@material-ui/core/Button';
import './OrderForm.css'

import { useSelector, useDispatch } from 'react-redux'
import { setRequesterInfo } from '../../features/counter/counterSlice'


function RequesterInfo(props) {


    const rInfo = useSelector((state) => state.counter.requesterInfo)
    const dispatch = useDispatch()

    useEffect(() => {
        // console.log( rInfo );
    }, []);


    const [phone, setPhone] = React.useState({
        country: "",
        number: "",
    });


    const [values, setValues] = React.useState(rInfo);


    const selectState = [
        { value: "AL", select: "Alabama" }, { value: "AK", select: "Alaska" }, { value: "AS", select: "American Samoa" }, { value: "AZ", select: "Arizona" }, { value: "AR", select: "Arkansas" }, { value: "CA", select: "California" }, { value: "CO", select: "Colorado" }, { value: "CT", select: "Connecticut" }, { value: "DE", select: "Delaware" }, { value: "DC", select: "District Of Columbia" }, { value: "FM", select: "Federated States Of Micronesia" }, { value: "FL", select: "Florida" }, { value: "GA", select: "Georgia" }, { value: "GU", select: "Guam" }, { value: "HI", select: "Hawaii" }, { value: "ID", select: "Idaho" }, { value: "IL", select: "Illinois" }, { value: "IN", select: "Indiana" }, { value: "IA", select: "Iowa" }, { value: "KS", select: "Kansas" }, { value: "KY", select: "Kentucky" }, { value: "LA", select: "Louisiana" }, { value: "ME", select: "Maine" }, { value: "MH", select: "Marshall Islands" }, { value: "MD", select: "Maryland" }, { value: "MA", select: "Massachusetts" }, { value: "MI", select: "Michigan" }, { value: "MN", select: "Minnesota" }, { value: "MS", select: "Mississippi" }, { value: "MO", select: "Missouri" }, { value: "MT", select: "Montana" }, { value: "NE", select: "Nebraska" }, { value: "NV", select: "Nevada" }, { value: "NH", select: "New Hampshire" }, { value: "NJ", select: "New Jersey" }, { value: "NM", select: "New Mexico" }, { value: "NY", select: "New York" }, { value: "NC", select: "North Carolina" }, { value: "ND", select: "North Dakota" }, { value: "MP", select: "Northern Mariana Islands" }, { value: "OH", select: "Ohio" }, { value: "OK", select: "Oklahoma" }, { value: "OR", select: "Oregon" }, { value: "PW", select: "Palau" }, { value: "PA", select: "Pennsylvania" }, { value: "PR", select: "Puerto Rico" }, { value: "RI", select: "Rhode Island" }, { value: "SC", select: "South Carolina" }, { value: "SD", select: "South Dakota" }, { value: "TN", select: "Tennessee" }, { value: "TX", select: "Texas" }, { value: "UT", select: "Utah" }, { value: "VT", select: "Vermont" }, { value: "VI", select: "Virgin Islands" }, { value: "VA", select: "Virginia" }, { value: "WA", select: "Washington" }, { value: "WV", select: "West Virginia" }, { value: "WI", select: "Wisconsin" }, { value: "WY", select: "Wyoming" }
    ];

    const handleChange = (prop) => (event) => {
        // console.log(event);
        let selectedValue;

        if (prop == 'shippingAddressSameAsBilling') {
            selectedValue = event;
            // console.log( selectedValue);
        } else {
            selectedValue = event.target.value;
        }
        setValues({
            ...values,
            [prop]: selectedValue
        });


        if (values.shippingAddressSameAsBilling) {
            let name = prop.replace('billing', 'shipping');
            // console.log(name);
            dispatch(setRequesterInfo({
                ...rInfo,
                [name]: selectedValue,
                [prop]: selectedValue,
            }));
        } else {
            dispatch(setRequesterInfo({
                ...rInfo,
                [prop]: selectedValue
            }));
        }
    };

    //save phone into values and also in rinfo 
    const handlePhoneChange = (newValue) => {
        setValues({
            ...values,
            phone: newValue
        });
        dispatch(setRequesterInfo({
            ...rInfo,
            phone: "+" + newValue
        }));
    };



    return (

        <div className="FormContainer">




            <div className="AccordionContianer">
                <div className='formHeaderCtn'>
                    <Button className='backbutton' href="#text-buttons"><ArrowBackIosRoundedIcon /> Back </Button>
                </div>

                <Accordion defaultExpanded>

                    <AccordionSummary aria-controls="panel1a-content" id="panel1a-header" >
                        <div className="aAccordionTitle" >Requester Info</div>
                    </AccordionSummary>

                    <AccordionDetails>
                        <Grid container spacing={2}>

                            {/* <Grid item md={12} sm={12} xs={12}>
                                <h1 className='formTitle'>Member details</h1>
                            </Grid> */}

                            <Grid item xs={12} md={6}>
                                <div className="field_box">
                                    <TextInputFixedLabel
                                        label="First name"
                                        labelStatus={true}
                                        value={values.firstName}
                                        onChange={handleChange('firstName')}
                                        error={props.errorObject.firstName}
                                        errortextStatus={props.errorObject.firstName}
                                        Errormessage="Please provide first name"
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <div className="field_box">
                                    <TextInputFixedLabel
                                        label="Last name"
                                        labelStatus={true}
                                        value={values.lastName}
                                        onChange={handleChange('lastName')}
                                        error={props.errorObject.lastName}
                                        required
                                        errortextStatus={props.errorObject.lastName}
                                        Errormessage="Please provide last name"
                                    />
                                </div>
                            </Grid>



                            <Grid item xs={12} md={8}>
                                <div className="field_box">
                                    <TextInputFixedLabel
                                        label="Resident street address"
                                        labelStatus={true}
                                        value={values.billingStreetAddress}
                                        onChange={handleChange('billingStreetAddress')}
                                        error={props.errorObject.billingStreetAddress}
                                        errortextStatus={props.errorObject.billingStreetAddress}
                                        Errormessage="Please provide street address"
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <div className="field_box">
                                    <TextInputFixedLabel
                                        label="Apt/Floor (Optional)"
                                        labelStatus={true}
                                        value={values.billingFloorNumber}
                                        onChange={handleChange('billingFloorNumber')}
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <div className="field_box">
                                    <TextInputFixedLabel
                                        label="City/Town"
                                        labelStatus={true}
                                        value={values.billingCity}
                                        onChange={handleChange('billingCity')}
                                        error={props.errorObject.billingCity}
                                        errortextStatus={props.errorObject.billingCity}
                                        Errormessage="Please provide city"
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <div className="field_box">
                                    <SelectFieldOne
                                        label="State/Province"
                                        selectdata={selectState}
                                        defaultValue={values.billingState}
                                        handleChange={handleChange('billingState')}
                                        error={props.errorObject.billingState}
                                        errortextStatus={props.errorObject.billingState}
                                        Errormessage="Please provide state"
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <div className="field_box">
                                    <TextInputFixedLabel
                                        label="Zip/Postal code"
                                        labelStatus={true}
                                        value={values.billingPostalCode}
                                        onChange={handleChange('billingPostalCode')}
                                        error={props.errorObject.billingPostalCode}
                                        errortextStatus={props.errorObject.billingPostalCode}
                                        Errormessage="Please provide postal code"
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <div className="field_box">
                                    <PhoneInputField
                                        phoneInputVariant={"materialui"} // default, materialui, underlineInput, underlineWithFlag
                                        country={'us'}
                                        value={values.phone}
                                        countryCodeEditable={false}
                                        onChange={(phone, country) => handlePhoneChange( phone )}
                                        onBlur={() => console.log("onBlur")}
                                        onKeyDown={(e) => console.log("onKeyDown", e.target.value)}
                                        variant="outlined"
                                        // onlyCountries={["us", "ca", "gb", "my"]}
                                        containerStyle={{}}
                                        buttonStyle={{}}
                                        inputStyle={{
                                            marginLeft: "0px",
                                            height: "40px",
                                            width: "100%",
                                            fontFamily: "Roboto-Regular",
                                            fontSize: "16px",
                                        }}
                                        containerClass={{}}
                                        errorStyles={{ marginBottom: "5px" }}
                                        autoFormat={true}
                                        disableDropdown={false}
                                        disabled={false}
                                        disableCountryCode={false}
                                        enableSearch={false}
                                        disableSearchIcon={false}
                                        placeholder={""}
                                        inputProps={{}}
                                        specialLabel={'Primary Phone'}
                                        // preferredCountries={[]}
                                        // excludeCountries={[]}
                                        labelFixed="Phone number"
                                        LabelStatus={true}
                                        //error="error"
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <div className="field_box">
                                    <TextInputFixedLabel
                                        label="Email address"
                                        labelStatus={true}
                                        value={values.email}
                                        onChange={handleChange('email')}
                                        helpertext="We’ll email you a receipt and order updates"
                                        HelpertextStatus={true}
                                        error={props.errorObject.email}
                                        errortextStatus={props.errorObject.email}
                                        Errormessage="Please provide email"
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <CheckBox
                                    label="Use the above address as shipping address"
                                    checked={values.shippingAddressSameAsBilling}
                                    onChange={handleChange('shippingAddressSameAsBilling')}
                                />

                            </Grid>


                        </Grid>
                    </AccordionDetails>

                </Accordion>


            </div>





        </div >
    );
}
export default RequesterInfo;


